module.exports = __webpack_public_path__ + "static/media/sv.716a0317.svg";